import React, { useEffect, useState } from 'react';
import { GoalsCurrentMonth } from './GoalsCurrentMonth';
import { GoalsHistory } from './GoalsHistory';
import { GoalsNextMonth } from './GoalsNextMonth';

import { Box, Button, Typography } from '@mui/material';
import { useDataProvider, useTranslate } from 'react-admin';
import { Link } from 'react-router-dom';
import noGoals from '../../assets/img/no-goals.png';
import { LoadingPage } from '../../components/LoadingPage';
import { hasRole } from '../../utils/roles';

export const GoalsList = () => {
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const [loading, setLoading] = useState(true);
  const [goals, setGoals] = useState([]);

  const getAllGoals = () => {
    dataProvider
      .getList('goals/all', {
        pagination: {},
        sort: { field: 'month', order: 'ASC' },
        filter: { progress: true },
      })
      .then(res => {
        const data = res.data;
        const groupedData = {
          closed: {},
          current: {},
          next: {},
        };
        data.forEach(item => {
          const status = item.status;
          const month = item.month;
          const team = item.team?.name || '(sin datos)';

          if (!groupedData[status][month]) {
            groupedData[status][month] = {};
          }

          if (!groupedData[status][month][team]) {
            groupedData[status][month][team] = [];
          }

          groupedData[status][month][team].push(item);
        });
        setGoals({ ...groupedData, total: res.total });
      })
      .catch(error => {
        console.error('Error fetching goals: ', error);
      })
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    getAllGoals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <LoadingPage />;
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingTop: '16px',
        }}
      >
        <Typography
          variant="h1"
          sx={{
            textAlign: 'center',
            fontSize: '32px',
            fontWeight: '700',
          }}
        >
          {translate('resources.goals.list.title')}
        </Typography>
        {hasRole(['admin', 'gerente']) ? (
          <Button variant="contained" component={Link} to="/goals/create">
            <span>{translate('resources.goals.create.title')}</span>
          </Button>
        ) : null}
      </Box>
      {goals && goals.total > 0 ? (
        <Box component={'section'} sx={{ mt: '20px', textAlign: 'center' }}>
          {goals.current && Object.keys(goals.current).length > 0
            ? Object.keys(goals.current).map((month, i) => (
                <GoalsCurrentMonth
                  key={i}
                  month={month}
                  goals={goals.current[month]}
                />
              ))
            : null}
          {goals.next && Object.keys(goals.next).length > 0
            ? Object.keys(goals.next).map((month, i) => (
                <GoalsNextMonth
                  key={i}
                  month={month}
                  goals={goals.next[month]}
                />
              ))
            : null}
          {goals.closed && Object.keys(goals.closed).length > 0 ? (
            <GoalsHistory goals={goals.closed} />
          ) : null}
        </Box>
      ) : (
        <Box component={'section'} sx={{ mt: '20px', textAlign: 'center' }}>
          <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            gap={4}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: '80px',
            }}
          >
            <img width={400} src={noGoals} alt="No hay objetivos" />
            <Box sx={{ maxWidth: '740px', margin: '0 auto' }}>
              <Typography
                variant="h6"
                sx={{
                  textAlign: 'center',
                  fontSize: '24px',
                  fontWeight: '600',
                }}
              >
                {translate('resources.goals.list.noGoals')}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  maxWidth: '500px',
                  margin: '0 auto',
                  textAlign: 'center',
                  fontSize: '16px',
                }}
              >
                {translate('resources.goals.list.noGoalsSub')}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};
